<div class="container-fluid wrapper-page">
  <div class="page-head">
    <h4 class="mt-2 mb-2">UPDATE ORGANISATION INFORMATION</h4>
  </div>
  <form #editFdeskForm="ngForm" enctype="multipart/form-data">
    <div class="row">
      <div class="col-lg-12">
        <div class="card m-b 30">
          <div class="card-body">
            <ul class="tablist">
              <li role="tab">
                <a class="nav-link" [ngClass]="{
                    active: editOrgCurrentTab == 'personalInformation'
                  }" href="javascript:void(0)" role="tab"><span class="number">1.</span>Demographical Information</a>
              </li>
            </ul>
            <!----========   PERSONAL INFORMATION =========================  -->
            <ng-container *ngIf="editOrgCurrentTab == 'personalInformation'">
              <section class="mt-3 ml-2 align-items-center">
                <div class="form-group row mb30">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="avaitarImg">
                          <!-- <img src="assets/new-ui/images/users/avatar.jpg" style="height: 180px; border-radius: 10px;"
                            class=""> -->
                          <label class="hoverable" for="fileInput">
                            <img [src]="organisation.opurl">
                            <div class="hover-text">Edit</div>
                            <div class="background"></div>
                          </label>
                          <br />
                          <input id="fileInput" type="file" (change)="fileSelected($event)">
                        </div>
                      </div>
                      <div class="col-md-8">
                        <h5 class="innerheading">Basic Information</h5>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Organisation Name</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('oname')">
                                <ng-template viewMode>{{
                                  organisation.oname || "Organisation Name"
                                  }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('oname')" focusable />
                                </ng-template>
                              </editable>
                              <span *ngIf="getControl('oname')?.errors?.required" class="invalid-feedback">
                                Organisation Name is required.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1"></div>
                </div>
                <br />
                <div class="form-group row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <div class="row mb10">
                      <div class="col-md-6">
                        <h5 class="innerheading">CONTACT DETAILS</h5>
                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Address</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('address1')">
                                <ng-template viewMode>{{
                                  organisation.address1 || "Address Line 1"
                                  }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address1')" focusable />
                                </ng-template>
                              </editable>
                              <span *ngIf="f.address1.errors" class="invalid-feedback">This is required</span>
                            </p>
                            <p>
                              <editable (update)="updateField('address2')">
                                <ng-template viewMode>{{ organisation.address2 || "Address Line 2" }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address2')" focusable />
                                </ng-template>
                              </editable>
                              <span *ngIf="f.address2.errors" class="invalid-feedback">This is required</span>
                            </p>

                            <p>
                              <editable (update)="updateField('city')">
                                <ng-template viewMode>{{ organisation.city|| "Enter City" }}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('city')" focusable />
                                </ng-template>
                              </editable>
                            </p>

                            <p>
                              <editable (update)="updateField('state')">
                                <ng-template viewMode>
                                  {{organisation && organisation?.state ? getStateName(organisation?.state) :
                                  "Enter State"}}
                                </ng-template>
                                <ng-template editMode>
                                  <select class="form-control" [formControl]="getControl('state')"
                                    formControlName="state" focusable>
                                    <option *ngFor="let x of states;let i = index" [value]="x.id">{{x?.name}}</option>
                                  </select></ng-template>
                              </editable>
                            </p>
                            <!--
                            <p>
                              <editable (update)="updateField('zip')">
                                <ng-template viewMode>
                                  {{ organisation && organisation?.zip ? (organisation?.zip) : "Enter ZipCode"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" formControlName="zip" [formControl]="getControl('zip')"
                                    focusable />
                                </ng-template>
                              </editable>
                              <span *ngIf="getControl('zip').errors" class="invalid-feedback">Invalid Zip Code.
                              </span>
                            </p> -->
                            <p>
                              <editable (update)="updateField('zip')">
                                <ng-template viewMode>
                                  {{organisation && organisation?.zip ? (organisation?.zip) : "Enter ZipCode"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('zip')" focusable>
                                </ng-template>
                              </editable>

                              <span *ngIf="f.zip.errors" class="invalid-feedback">Invalid Zip Code.
                              </span>
                            </p>

                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Contact</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('contact_no')">
                              <ng-template viewMode>{{
                                organisation.contact_no ||
                                "Change contact number"
                                }}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('contact_no')" focusable
                                  maxlength="12" minlength="10" />

                              </ng-template>
                            </editable>
                            <span *ngIf="getControl('contact_no').errors" class="invalid-feedback">
                              Invalid Contact Number.
                            </span>
                            <span *ngIf="
                                f.contact_no.errors &&
                                f.contact_no.errors.required
                              " class="invalid-feedback">This is required</span>
                          </div>
                        </div>
                        <div class="row" mb10>
                          <div class="col-6 col-md-4">
                            <label>Email</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('org_eid')">
                              <ng-template viewMode>{{ organisation.org_eid || "Change email-id"}}
                              </ng-template>

                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('org_eid')" focusable />

                              </ng-template>
                            </editable>
                            <div *ngIf="getControl('org_eid')?.errors?.required" class="invalid-feedback">
                              Email is required.
                            </div>
                            <div *ngIf="getControl('org_eid')?.errors?.pattern" class="invalid-feedback">
                              Invalid Email.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1"></div>
                </div>
              </section>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-10"></div>
      <div class="col-2">
        <button type="button" (click)="saveOrg()" [disabled]="forms['personalInformation'].invalid"
          class="btn btn-primary btn-patient pull-right">
          Update
        </button>
      </div>
    </div>
  </form>
</div>